<template>
  <div class="form-group" :class="{ 'has-error': errors.has(fieldId, scope) }">
    <label v-if="label">{{ label }}</label>
    <span class="static-field" v-if="readonly && selectedValue">{{ selectedValue.label }}</span>
    <v-select v-if="!readonly"
              :value="selectedValue"
              @input="updateValue($event)"
              :placeholder="placeholder"
              :multiple="multiple"
              :searchable="searchable"
              :filter-by="filterBy"
              :options="options"></v-select>
    <input type="hidden"
           :name="fieldId"
           :id="fieldId"
           :value="value"
           ref="input"
           v-validate="validation"
           data-vv-value-path="value"
           data-vv-validate-on="input">
    <p class="text-danger" v-if="errors.has(fieldId, scope)">{{ errors.first(fieldId, scope) }}</p>
  </div>
</template>
<script>
  import _ from 'lodash';
  import { normalize } from 'utils';
  import vSelect from 'vue-select';

export default {
  inject: ['$validator'],
  components: {vSelect},
  data: () => ({
    selectedValue: null
  }),
  props: {
    value: {
      default: null
    },
    label: {
      type: String,
      required: false
    },
    fieldId: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    scope: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      required: true,
      default () {
        return [];
      }
    },
    validation: {
      type: String,
      default () {
        return '';
      }
    },
    codelist: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: true
    },
    filterBy: {
      type: Function,
      default(option, label, search) {
        return normalize(label).indexOf(normalize(search)) > -1;
      }
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateValue(value) {
      this.selectedValue = value;
      this.$emit('input', !!value && this.codelist ? value.value : value);
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.selectedValue = !!this.value && this.codelist ? _.find(this.options, {value: this.value}) : this.value;
      } else {
        this.selectedValue = null;
      }
    }
  },
  mounted() {
    //for initial fill -> watch doesn't work here
    this.selectedValue = !!this.value && this.codelist ? _.find(this.options, {value: this.value}) : this.value;
  }
}
</script>



// WEBPACK FOOTER //
// client/components/form/selectField.vue